import { useNavigate } from 'react-router-dom'

import { Box, Icon, List, StatusLabel, Text } from '@factorialco/deprecated-design-system'
import { CvBulkCandidateFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  newCandidates: CvBulkCandidateFragment[]
}
export const NewCandidatesList = ({ newCandidates }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box gap="s8">
      <StatusLabel type="positive">
        {i18n.t('ats.candidates.upload_resumes.status.completed')}
      </StatusLabel>
      <Box gap="s4" paddingBottom="s8">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('ats.candidates.upload_resumes.sidepanel.new_candidates.title')}
        </Text.Normal>
        <Text.Normal>
          {i18n.t('ats.candidates.upload_resumes.sidepanel.new_candidates.description')}
        </Text.Normal>
      </Box>
      <List>
        {newCandidates.map((candidate) => (
          <List.ClickableItem
            key={`newcandidate-${candidate.id}`}
            navigateTo={() =>
              navigate(navigation.ats.candidates.id.applications.fullPath({ id: candidate.id }))
            }
          >
            <List.Title>{candidate.fullName}</List.Title>
            <List.ActionItem>
              <Icon.Medium icon="arrow-right" />
            </List.ActionItem>
          </List.ClickableItem>
        ))}
      </List>
    </Box>
  )
}
